var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37356 13.7721C3.21668 13.9239 3.01659 14 2.8076 14C2.59854 14 2.39839 13.9239 2.24149 13.7719C1.9195 13.4602 1.9195 12.9481 2.24149 12.6363L7.03001 8L2.24149 3.36367C1.9195 3.05191 1.9195 2.53981 2.24149 2.22805C2.55546 1.92407 3.05937 1.92398 3.37344 2.22779L8.75837 7.43193C9.08036 7.74369 9.08063 8.25605 8.75864 8.56781L3.37356 13.7721Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37356 13.7721C8.21668 13.9239 8.01659 14 7.8076 14C7.59854 14 7.39839 13.9239 7.24149 13.7719C6.9195 13.4602 6.9195 12.9481 7.24149 12.6363L12.03 8L7.24149 3.36367C6.9195 3.05191 6.9195 2.53981 7.24149 2.22805C7.55546 1.92407 8.05937 1.92398 8.37344 2.22779L13.7584 7.43193C14.0804 7.74369 14.0806 8.25605 13.7586 8.56781L8.37356 13.7721Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleRight);
export default __webpack_public_path__ + "static/media/arrowDoubleRight.cf8d4171a1ccdabd1aa56b65abf957e2.svg";
export { ForwardRef as ReactComponent };